import { render, staticRenderFns } from "./OtherIncome.vue?vue&type=template&id=b4c8bc30&scoped=true&"
import script from "./OtherIncome.vue?vue&type=script&lang=js&"
export * from "./OtherIncome.vue?vue&type=script&lang=js&"
import style0 from "./OtherIncome.vue?vue&type=style&index=0&id=b4c8bc30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c8bc30",
  null
  
)

export default component.exports